import type { PathKind, SchemaPath, SchemaPathRules } from '@angular/forms/signals';
import { minLength, validate } from '@angular/forms/signals';

const PASSWORD_MIN_LENGTH = 8;

export function passwordStrengthRules<TPathKind extends PathKind = PathKind.Root>(
  path: SchemaPath<string, SchemaPathRules.Supported, TPathKind>,
): void {
  minLength(path, PASSWORD_MIN_LENGTH, {
    message: `Heslo musí mít minimálně ${PASSWORD_MIN_LENGTH} znaků`,
  });
  validate(path, ({ value }) => {
    if (value() && !/[A-Z]/.test(value()))
      return { kind: 'uppercase', message: 'Heslo musí obsahovat alespoň jedno velké písmeno' };
    return null;
  });
  validate(path, ({ value }) => {
    if (value() && !/[a-z]/.test(value()))
      return { kind: 'lowercase', message: 'Heslo musí obsahovat alespoň jedno malé písmeno' };
    return null;
  });
  validate(path, ({ value }) => {
    if (value() && !/[0-9]/.test(value()))
      return { kind: 'digit', message: 'Heslo musí obsahovat alespoň jednu číslici' };
    return null;
  });
}
